import React, { useState } from "react";
import './App.css';
import Contact from './Pages/Contact/Contact';
import Home from './Pages/Home/Home';
import Aboutus from './Pages/Aboutus/Aboutus';
import Header from './Component/Header/Header';
import Footer from './Component/Footer/Footer';
import ProductDetail from './Pages/ProductDetail/ProductDetail';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Services from "./Pages/Services/Services";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProductPage from "./Component/ProductPage";
import CartDrawer from "./Component/CartDrawer";
import "./Styles/style.css";
import ReachUsForm from './Component/Forms/ReachUsForm';
import RaiseRequestForm from './Component/Forms/RaiseRequestForm';
import SolarCalculator from "./Component/Header/SolarCalculator";
import RentalProduct from "./Pages/RentalProduct/RentalProduct";
import Portfolio from "./Component/Portfolio";

function App() {
  const [cartItems, setCartItems] = useState([]);
  const [open, setOpen] = useState(false);

  // Add to cart
  const handleAddToCart = (product) => {
    const exist = cartItems.find((x) => x.id === product.id);
    if (exist) {
      setCartItems(
        cartItems.map((x) =>
          x.id === product.id ? { ...x, qty: x.qty + 1 } : x
        )
      );
    } else {
      setCartItems([...cartItems, { ...product, qty: 1 }]);
    }
    setOpen(true);
  };

  return (
    <Router>
      <div className="App">
        {/* Header */}
        <Header cartItems={cartItems} setOpen={setOpen} />

        {/* Pages */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Aboutus />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/products" element={<ProductPage handleAddToCart={handleAddToCart} />} />
          <Route path="/products/rental" element={<RentalProduct handleAddToCart={handleAddToCart} />}/>
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/calculator" element={<SolarCalculator />} />
          <Route path="/reach-us" element={<ReachUsForm />} />
          <Route path="/raise-request" element={<RaiseRequestForm />} />
        </Routes>

        {/* Footer */}
        <Footer />

        {/* Cart Drawer */}
        <CartDrawer
          open={open}
          setOpen={setOpen}
          cartItems={cartItems}
          setCartItems={setCartItems}
        />
      </div>
    </Router>
  );
}

export default App;